// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_QABon","active":"index_active_vuuI6"};